<ng-container *ngIf="!isTeaserBet; else teaserSlip">
    <bs-digital-result-succeeded-slip
        *ngFor="let slip of succeededSlips"
        [slip]="slip"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [possibleWinningTitle]="possibleWinningTitle"
        [tokenPayoutSummary]="getSlipTokenPayoutSummary(slip)"></bs-digital-result-succeeded-slip>
</ng-container>

<ng-template #teaserSlip>
    <bs-digital-result-succeeded-teaser-slip
        *ngFor="let slip of succeededSlips"
        [slip]="slip"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [teasedPoints]="teasedPoints">
    </bs-digital-result-succeeded-teaser-slip>
</ng-template>
